/**
 * Schema estruturado para a seção de planejamento de aposentadoria
 * Formato: Schema.org - FinancialProduct
 */
export const retirementSchema = {
  '@context': 'https://schema.org',
  '@type': 'FinancialProduct',
  'name': 'Planejador de Aposentadoria',
  'description': 'Calcule quanto você precisa investir para se aposentar e viver de renda passiva.',
  'category': 'Retirement Planning',
  'broker': {
    '@type': 'FinancialService',
    'name': 'Calculadora de Juros Compostos',
    'url': 'https://calculadora-juros-compostos.com/aposentadoria'
  },
  'featureList': 'Cálculo de capital necessário para independência financeira, Projeção de renda passiva, Ajuste para inflação, Estimativa de tempo até a aposentadoria',
  'termsOfService': 'https://calculadora-juros-compostos.com/termos',
  'aggregateRating': {
    '@type': 'AggregateRating',
    'ratingValue': '4.7',
    'ratingCount': '85'
  }
};
